(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atalay-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-atalay-tabs]').forEach((block) => {
    const tabs = block.querySelectorAll('[data-tab]');
    const panels = block.querySelectorAll('[data-panel]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('is-active'));
      panels.forEach((p) => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      const panel = block.querySelector('[data-panel="' + tab.dataset.tab + '"]');
      if (panel) panel.classList.add('is-active');
    }));
    // Ilk sekme bos koleksiyon yuzunden gizlendiyse ilk gorunur sekmeyi aktif et
    if (tabs.length && !block.querySelector('[data-tab].is-active')) {
      tabs[0].classList.add('is-active');
      const p0 = block.querySelector('[data-panel="' + tabs[0].dataset.tab + '"]');
      if (p0) p0.classList.add('is-active');
    }
  });
  document.querySelectorAll('[data-atalay-products]').forEach((section) => {
    section.querySelectorAll('[data-panel]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-panel]').forEach((item) => item.classList.remove('is-active'));
        section.querySelectorAll('[data-product-panel]').forEach((panel) => { panel.hidden = true; panel.classList.remove('is-active'); });
        button.classList.add('is-active');
        const panel = section.querySelector(`[data-product-panel="${button.dataset.panel}"]`);
        if (panel) { panel.hidden = false; panel.classList.add('is-active'); }
      });
    });
  });
  document.querySelectorAll('[data-atalay-location]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.atalay-location');
      const status = wrapper.querySelector('[data-atalay-location-status]');
      const field = wrapper.querySelector('[data-atalay-coordinates]');
      if (!navigator.geolocation) { status.textContent = 'Konum paylaşımı bu cihazda desteklenmiyor.'; return; }
      status.textContent = 'Konum izni bekleniyor…';
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        const lat = coords.latitude.toFixed(6), lng = coords.longitude.toFixed(6);
        field.value = `${lat},${lng} — https://maps.google.com/?q=${lat},${lng}`;
        status.textContent = '✓ Konum eklendi — adres getiriliyor…';
        status.classList.remove('is-err');
        // Konumdan adresi otomatik doldur (musteri duzenleyebilir)
        const form = button.closest('form');
        const adresEl = form && form.querySelector('[name="contact[Servis adresi]"]');
        if (adresEl && !adresEl.value.trim()) {
          fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=tr`)
            .then((r) => r.json())
            .then((d) => {
              const a = (d && d.address) || {};
              const parca = [
                a.road || a.pedestrian || '',
                a.house_number ? 'No:' + a.house_number : '',
                a.neighbourhood || a.quarter || a.suburb || '',
                a.town || a.city_district || a.county || a.district || '',
                a.province || a.state || a.city || ''
              ].filter(Boolean);
              if (parca.length && !adresEl.value.trim()) {
                adresEl.value = parca.join(', ');
                status.textContent = '✓ Konum ve adres eklendi — adresi kontrol edip kapı/daire no ekleyin.';
                adresEl.focus();
              } else { status.textContent = '✓ Konum servis talebine eklendi.'; }
            }).catch(() => { status.textContent = '✓ Konum eklendi — adresi elle yazabilirsiniz.'; });
        } else { status.textContent = '✓ Konum servis talebine eklendi.'; }
      }, () => { status.textContent = '⚠ Konum alınamadı — tarayıcı izinlerini kontrol edip tekrar deneyin (zorunlu).'; status.classList.add('is-err'); }, { enableHighAccuracy: true, timeout: 10000 });
    });
  });
  // Konum zorunlu + randevu formu API'ye gider (takip no + mail + foto)
  document.querySelectorAll('[data-atalay-coordinates]').forEach((field) => {
    const form = field.closest('form');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      if (!field.value.trim()) {
        e.preventDefault();
        const wrapper = form.querySelector('.atalay-location');
        const status = wrapper && wrapper.querySelector('[data-atalay-location-status]');
        if (status) { status.textContent = '⚠ Konum paylaşımı zorunludur — "Konumumu ekle" butonuna basın.'; status.classList.add('is-err'); }
        const btn = wrapper && wrapper.querySelector('[data-atalay-location]');
        if (btn) { btn.classList.add('is-required'); btn.click(); }
        wrapper && wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      e.preventDefault();
      const val = (n) => { const el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      const sbtn = form.querySelector('.atalay-submit');
      if (sbtn) { sbtn.disabled = true; sbtn.dataset.t = sbtn.textContent; sbtn.textContent = 'Gönderiliyor…'; }
      fetch('https://app.groheyetkiliservis.com.tr/api/randevu', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ad: val('contact[name]'), telefon: val('contact[phone]'), eposta: val('contact[email]'),
          marka: val('contact[Marka]'), hizmet: val('contact[Hizmet]'), aciklama: val('contact[body]'),
          adres: val('contact[Servis adresi]'), konum: field.value.trim(),
          tarih: val('contact[Randevu tarihi]'), saat: val('contact[Uygun saat]'), kaynak: 'site-anasayfa'
        })
      }).then((r) => r.json()).then((d) => {
        if (!d || !d.ok) throw new Error('api');
        form.style.display = 'none';
        const done = document.createElement('div');
        done.className = 'atalay-form-done';
        done.innerHTML = '<i>✓</i><h3>Servis talebiniz alındı</h3>'
          + '<p>' + (d.mail ? 'Gerekli bilgiler <b>e-posta adresinize</b> gönderildi. ' : '') + 'Teknik ekibimiz en kısa sürede sizinle iletişime geçecek.</p>'
          + '<div class="atalay-form-done__kod"><span>SERVİS TAKİP NO</span><b>' + (d.takip_kod || '') + '</b></div>'
          + (d.takip_kod ? '<button type="button" class="atalay-form-done__foto">📷 Arıza fotoğrafı ekle</button>' : '')
          + (d.takip_url ? '<a href="' + d.takip_url + '" target="_blank" rel="noopener">Servis Sürecimi Takip Et →</a>' : '');
        form.parentElement.appendChild(done);
        const fbtn = done.querySelector('.atalay-form-done__foto');
        fbtn && fbtn.addEventListener('click', () => { window.atFotoYukle && window.atFotoYukle(d.takip_kod); });
        done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(() => {
        if (sbtn) { sbtn.disabled = false; if (sbtn.dataset.t) sbtn.textContent = sbtn.dataset.t; }
        HTMLFormElement.prototype.submit.call(form);
      });
    });
  });
  // Parca bulucu: canli oneri + preloader (hero + yedek parca arama kutusu, hepsi [data-at-finder])
  document.querySelectorAll('[data-at-finder]').forEach(function (f) {
    const inp = f.querySelector('input[type=search]');
    const btn = f.querySelector('button');
    const panel = f.querySelector('[data-finder-panel]');
    let t, last = '', reqNo = 0;
    // 15.09: suggest.json fiyati TL olarak ("2451.73") verir, kurus DEGIL — 100'e bolme
    const money = (v) => { const n = parseFloat(v); if (!isFinite(n)) return ''; try { return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; } catch (e) { return ''; } };
    const rank = (list, q) => { const k = q.toLowerCase(); return list.slice().sort((a, b) => (String(b.title || '').toLowerCase().includes(k)) - (String(a.title || '').toLowerCase().includes(k))); };
    inp.addEventListener('input', () => {
      const q = inp.value.trim();
      if (q === last) return; last = q;
      clearTimeout(t);
      const my = ++reqNo;
      if (q.length < 2) { panel.hidden = true; btn.classList.remove('is-loading'); return; }
      btn.classList.add('is-loading');
      const finderUrl = (qq) => '/search/suggest.json?q=' + encodeURIComponent(qq) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag';
      const getPs = (d) => (d.resources && d.resources.results && d.resources.results.products) || [];
      const draw = (ps) => {
        btn.classList.remove('is-loading');
        if (!ps.length) { panel.innerHTML = '<div class="at-hero__finder-empty">Sonuç bulunamadı — kodu <a href="https://wa.me/905412686675" target="_blank" rel="noopener">WhatsApp\'tan</a> sorabilirsiniz.</div>'; panel.hidden = false; return; }
        panel.innerHTML = ps.map((p) => {
          const img = (p.featured_image && p.featured_image.url) || '';
          return '<a href="' + p.url + '"><span class="thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span><span class="meta"><em>' + (p.vendor || '') + '</em><strong>' + p.title + '</strong></span><b>' + (p.price ? money(p.price) : '') + '</b></a>';
        }).join('') + '<a class="all" href="/search?q=' + encodeURIComponent(inp.value.trim()) + '&type=product">Tüm sonuçlar →</a>';
        panel.hidden = false;
      };
      t = setTimeout(() => {
        fetch(finderUrl(q)).then((r) => r.json()).then((d) => {
          if (my !== reqNo) return;
          const ps = getPs(d);
          const bareCode = /^[0-9][0-9a-z.\-]{3,}$/i.test(q);
          if (ps.length || !bareCode) { draw(ps); return; }
          Promise.all(['GRH', 'HNG', 'DRV', 'GBR', 'HPC', 'ISV'].map((p) =>
            fetch(finderUrl(p + q + '*')).then((r) => r.json()).then(getPs).catch(() => [])
          )).then((arrs) => {
            if (my !== reqNo) return;
            const seen = {}; const merged = [];
            arrs.forEach((a) => a.forEach((p) => { if (!seen[p.url]) { seen[p.url] = 1; merged.push(p); } }));
            draw(rank(merged, q).slice(0, 5));
          });
        }).catch(() => { if (my === reqNo) btn.classList.remove('is-loading'); });
      }, 230);
    });
    document.addEventListener('click', (e) => { if (!f.contains(e.target)) panel.hidden = true; });
    inp.addEventListener('focus', () => { if (panel.innerHTML && inp.value.trim().length >= 2) panel.hidden = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
